<script setup lang="ts">
  import { watch } from 'vue';
  import RestaurantPos from '@/components/pages/restaurant/RestaurantPos.vue';
  import PosV2Page from './PosV2Page.vue';
  import { usePosV2 } from '@/composition/use-pos-v2';
  import { useGtag } from '@/composition/use-gtag';
  import { useRestaurantStore } from '@/stores/restaurant.store';
  import { useRoute, useRouter } from 'vue-router/composables';

  const { isPosV2Active } = usePosV2();
  const restaurantStore = useRestaurantStore();
  const route = useRoute();
  const router = useRouter();
  const gtag = useGtag();

  if (route.path.endsWith('/realtime')) {
    router.replace(`/${restaurantStore.restaurant.stringId}/pos`);
  }

  watch(
    isPosV2Active,
    (active) => {
      if (!active || sessionStorage.getItem('posV2ActiveTracked')) return;
      sessionStorage.setItem('posV2ActiveTracked', '1');
      gtag.event('posv2_active', { event_category: 'posV2' });
    },
    { immediate: true }
  );
</script>

<template>
  <PosV2Page v-if="isPosV2Active" />
  <RestaurantPos v-else />
</template>
